<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="confirmarAprovacao()">
            <span> <i class="fa fa-check-circle-o mr-2"></i> Aprovar </span>
        </b-button>
    </div>
</template>

<script>
import AtualizacoesCadastraisServicos from './AtualizacoesCadastraisServicos'

export default {
    props: {
        atualizacaoCadastralId: {
            type: String,
            default: ''
        },

        cpfCnpj: {
            type: String,
            default: ''
        },

        razaoSocial: {
            type: String,
            default: ''
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarAprovacao() {
            this.$swal({
                title: 'Atualização Cadastral',
                html: `Confirma a APROVAÇÃO da atualização cadastral do fornecedor
                    ${this.cpfCnpj} - ${this.razaoSocial}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.aprovar()
                }
            })
        },

        aprovar() {
            this.$store.dispatch('addRequest')
            AtualizacoesCadastraisServicos.aprovar(
                this.atualizacaoCadastralId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso(response.data)
                    } else {
                        this.$emit('atualizarErro', response.errors)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso(data) {
            this.$toast.success(
                'Atualização cadastral aprovada com sucesso',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterAtualizacaoCadastralAtualizada')
        }
    }
}
</script>
